import { render, staticRenderFns } from "./MobileJoin.vue?vue&type=template&id=6b0dda2b&scoped=true&"
import script from "./MobileJoin.vue?vue&type=script&lang=js&"
export * from "./MobileJoin.vue?vue&type=script&lang=js&"
import style0 from "./MobileJoin.vue?vue&type=style&index=0&id=6b0dda2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0dda2b",
  null
  
)

export default component.exports